import QueryReportsContainer from "./QueryReportsContainer";

export default QueryReportsContainer;
